import { Reservation } from "twilio-taskrouter";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { CbmImpl } from "~/modules/cbm";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { getReservationsByTask, sendTrackingEvent } from "../../ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { Action } from "~/modules/actions/Action";


















export class RejectTask implements Action<Promise<Reservation>> {
    


    #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.getInstanceOf(TaskRouterImpl);
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.getInstanceOf(AnalyticsImpl);
        const cbm = context.getInstanceOf(CbmImpl);

        logger.debug(`rejectTask invoked with taskSid: ${this.#taskSid}`);

        if (!worker) {
            const errorMsg = "rejectTask: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "pending");

        if (!reservation) {
            const errorMsg = `rejectTask: Reservation for task ${this.#taskSid} not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.RejectTaskCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        try {
            await cbm.rejectReservation(reservation);
            sendTrackingEvent(EVENTS.RejectTaskCompleted, analytics, worker);
            return reservation;
        } catch (error) {
            const errorMsg = `rejectTask: Failed to reject reservation ${reservation.sid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.RejectTaskCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
